<template>
  <div class="examples-feedback-block">
    <div class="card-block">
      <div class="title">
        <img src="@/assets/imgs/icon47.png" />
        <span>润色前后对比</span>
      </div>

      <div class="info">
        <el-row :gutter="20">
          <el-col :span="12">
            <img src="@/assets/imgs/test/1.png" />
          </el-col>
          <el-col :span="12">
            <img src="@/assets/imgs/test/2.png" />
          </el-col>
          <el-col :span="24">
            <img src="@/assets/imgs/test/3.png" />
            <img src="@/assets/imgs/test/12.png" />
            <img src="@/assets/imgs/test/5.png" />
            <img src="@/assets/imgs/test/6.png" />
          </el-col>
          <el-col :span="12">
            <img src="@/assets/imgs/test/10.png" />
          </el-col>
          <el-col :span="12">
            <img src="@/assets/imgs/test/11.png" />
          </el-col>
        </el-row>
      </div>
    </div>

    <div class="card-block">
      <div class="title">
        <img src="@/assets/imgs/icon33.png" />
        <span>润色证明示例</span>
      </div>

      <div class="info">
        <img src="@/assets/imgs/test/9.png" />
      </div>
    </div>

    <div class="card-block">
      <div class="title">
        <img src="@/assets/imgs/icon43.png" />
        <span>视频一对一指导服务示例</span>
      </div>

      <div class="info">
        <img src="@/assets/imgs/test/4.png" />
      </div>
    </div>

    <div class="card-block">
      <div class="title">
        <img src="@/assets/imgs/icon35.png" />
        <span>发票示例</span>
      </div>

      <div class="info">
        <img src="@/assets/imgs/test/8.png" />
      </div>
    </div>

    <div class="card-block">
      <div class="title">
        <img src="@/assets/imgs/icon38.png" />
        <span>服务协议模板</span>
      </div>

      <div class="info">
        <div class="download">
          <el-button type="success">润色协议模版</el-button>
          <el-button @click="download(1)" icon="el-icon-download" type="primary">下载</el-button>
        </div>
      </div>
    </div>

    <div class="card-block">
      <div class="title">
        <img src="@/assets/imgs/icon49.png" />
        <span>润色总结与写作指导示例</span>
      </div>

      <div class="info">
        <div class="download">
          <el-button type="success">润色总结与写作指导示例</el-button>
          <el-button @click="download(2)" icon="el-icon-download" type="primary">下载</el-button>
        </div>
      </div>
    </div>

    <div class="card-block">
      <div class="title">
        <img src="@/assets/imgs/icon36.png" />
        <span>作者反馈</span>
      </div>
      <div class="info">
        <h3>
          我们已经为国内数十个大学、研究所的科研人员提供了高质量的论文服务，他们的论文已经发表在高质量的国际学术期刊上，我们的服务已经得到了广大科研用户的肯定。
        </h3>
      </div>
      <el-carousel trigger="click" height="200px">
        <el-carousel-item v-for="item in carouselList" :key="item.title">
          <div class="info">
            <h2>{{item.title}}</h2>
            <p>{{item.detail}}</p>
          </div>
        </el-carousel-item>
      </el-carousel>

      <!-- <div class="info">
        <h2>Cristina Milesi前NASA科学家</h2>
        <p>CropSnap LLC / NASA Ames Research Center (Former), Moffett Field, USA.</p>
        <p>Expertise: Remote Sensing, Ecosystem Modeling, Geography & Geospatia Technology.</p>
        <p>国际著名地球科学专家、生态学家，美国硅谷CropSnap科技/科研服务公司创始人。前NASA AMES研究中心科学家。先后指导来自中国的硕士/博士生、访问学者数十位，与中国作者合作发表大量SCI论文，具有极其丰富的论文写作及润色经验。</p>
      </div> -->
    </div>

    <div class="card-block">
      <div class="title">
        <img src="@/assets/imgs/icon48.png" />
        <span>近期服务成果</span>
      </div>

      <div class="info">
        <h3>本平台已为数百篇高水平SCI论文提供语言服务，初次投稿语言合格率高达95%，论文中稿率达70%！</h3>
        <p>来自北师大的论文经润色发表在 Remote Sensing of Enviroment 。</p>
        <p>来自中科院空天院的论文经润色发表在IEEE TGRS。</p>
        <p>来自北京大学的论文经润色发表在Remote Sensing。</p>
        <p>来自南京大学的论文经润色发表在 Remote Sensing of Enviroment 。</p>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * @description 论文润色 - 样例与反馈
 */
// import * as api from '@/api/login'

export default {
  name: 'ExamplesFeedback',
  data() {
    return {
      // 作者反馈的轮播数据
      carouselList: [
        {
          title: '华中农业大学某教授',
          detail: 'Schull博士本身就是植被遥感领域的专家，我选择了一小时的视频指导服务，这种形式真的非常好，不仅对文章改的很有针对性，也让我学会了很多专业化的表达，明显提升了我今后的写作水平。润色编辑是行业专家非常有必要，我的课题组将长期使用这种C2C的科研服务模式。',
        },
        {
          title: '中科院某研究员',
          detail: '我的论文是由定量遥感领域泰斗级大专家亲自帮忙润色的，这位专家的H-index高达100以上，具有非常丰富的论文尤其是Nature级别高水平论文的撰写与发表经验，我的论文经润色后得到明显提升，收益啦！论文现在已经顺利发表在本领域顶级刊物IEEE TGRS上啦。',
        },
        {
          title: '北京师范大学某博士',
          detail: 'Cristina教授对我的论文进行了非常细致的修改，并通过一对一视频对我写作中出现的问题进行了细致归纳与总结，这对我以后科研论文的发表帮助很大，现在这篇论文已经顺利发表在Remote Sensing of Enviroment上了！',
        },
        {
          title: '武汉大学某博士后',
          detail: '经其他老师推荐，抱着试试的态度试用了这个平台的服务，获得了非常Amazing的体验！不同于传统的润色公司，这个平台提供润色的人员都是国外一线学者，我的论文里竟然引用了两篇负责我论文润色的专家的文章，绝对是本领域的专业人士，论文改的非常好！强烈推荐！',
        },
        {
          title: '南京师范大学某讲师',
          detail: '这是我第三次使用这个平台的润色服务了，对自己写的论文总是不够自信…这次我选择了视频指导服务，专家40分钟的耐心指导让我从开始的紧张到后面的游刃有余，真的学到了很多，从提高自身写作水平的角度来说，这个服务性价比非常高，报销也很顺畅~',
        }
      ]
    }
  },
  created() {},
  methods: {
    /**
     * @description 模板下载
     */
    download(_type) {
      let _url =
        'agreement/%E6%B6%A6%E8%89%B2%E5%8D%8F%E8%AE%AE%E6%A8%A1%E6%9D%BF.pdf'
      if (_type == 2) {
        _url =
          'agreement/%E6%B6%A6%E8%89%B2%E6%80%BB%E7%BB%93%E4%B8%8E%E5%86%99%E4%BD%9C%E6%8C%87%E5%AF%BC%E7%A4%BA%E4%BE%8B.pdf'
      }
      window.open(`${this.$store.state.user.urlLink}${_url}`)
    },

    //     /**
    //  * @description 获取角色列表
    //  */
    // getListByPage() {
    //   const _this = this
    //   _this.tableLoading = true
    //   const _param = {
    //     page: _this.pageparm.page,
    //     size: _this.pageparm.size,
    //     roleName: _this.pageparm.roleName,
    //     orgid: _this.pageparm.orgid
    //   }
    //   api.listByPage(_param)
    //     .then(res => {
    //       const data = res.data
    //       _this.tableLoading = false
    //       _this.listData = data.result
    //       _this.pageparm.total = data.pageTotalCount
    //     })
    //     // .catch(err => {
    //     // })
    // },
  },
}
</script>
<style lang="scss" scoped>
.examples-feedback-block {
  .card-block {
    // width: 100%;
    padding: 20px;
    margin: 0 0 40px 0;
    background: #ffffff;
    border: 1px solid #dfdfdf;
    -moz-box-shadow: 15px 15px 0 #dddddd; /* 老的 Firefox */
    box-shadow: 15px 15px 0 #dddddd;

    .title {
      display: flex;
      align-items: center;
      font-size: 24px;
      padding: 0 20px 20px 20px;
      border-bottom: 1px solid #dcdfe6;

      img {
        display: block;
        width: 30px;
        margin: 0 10px 0 0;
      }
    }

    .info {
      padding: 0 20px;

      p {
        color: #98a5a6;
        line-height: 1.6;
        margin: 0;
      }

      img {
        display: block;
        margin: 15px auto 0 auto;
        // max-width: 100%;
        width: 100%;
      }

      // .img100 {
      //   width: 100%;
      // }

      // .img-list {
      //   display: flex;
      //   img {
      //     max-width: 100%;
      //     width: auto;
      //   }
      // }

      .download {
        margin: 15px 0 0 0;

        .el-button--success {
          background-color: #57b99d;
          border-color: #57b99d;
        }

        .el-button--primary {
          background-color: $colorNormal;
          border-color: $colorNormal;
        }
      }
    }
  }
}
</style>